module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('group', {
    attrs: {
      "title": "cell demo"
    }
  }, [_c('cell', {
    attrs: {
      "title": "Vux",
      "value": "Cool",
      "is-link": ""
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-demo"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/vux_logo.png")
    }
  }), _vm._v(" "), _c('h1')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-7d13442c!./~/.1.0.35@vux-loader/src/template-loader.js!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/HelloFromVux.vue
// module id = 316
// module chunks = 2